module.exports = __webpack_public_path__ + "img/teamviewer-2.32657871.png";